export default __webpack_public_path__ + "static/kia-rio-xline-2f6482a6040c2af83f6a776a378364dd.jpg";